const validate = (value) => {
    return value.trim();
}

export default {
    validate,
}